/**
 * Scroll to the element
 * @param el dom element
 */
export default (el) =>
  setTimeout(() => {
    const dataKey = el.getAttribute('data-key');
    const element = document.querySelector(`[data-key='${dataKey}']`);
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }, 0);
